
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import RemovalsHero from './components/RemovalsHero';
import RemovalsServices from './components/RemovalsServices';
import RemovalsProcess from './components/RemovalsProcess';
import RemovalsAreas from './components/RemovalsAreas';
import RemovalsFAQ from './components/RemovalsFAQ';
import QuoteSidebar from './components/QuoteSidebar';

const RemovalsPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <RemovalsHero />
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                <RemovalsServices />
                <RemovalsProcess />
                <RemovalsAreas />
                <RemovalsFAQ />
              </div>
              <div className="lg:col-span-1">
                <QuoteSidebar />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default RemovalsPage;
